import { GOOGLE_MAPS_KEY } from '@/config/config'

declare global {
  interface Window {
    __caiGoogleMapsLoaded?: () => void
  }
}

let loadPromise: Promise<void> | null = null

/** Load the Google Maps JS API (Places library) once, resolving when ready. */
export function loadGoogleMaps(): Promise<void> {
  if (loadPromise) return loadPromise

  loadPromise = new Promise<void>((resolve, reject) => {
    // @types/google.maps types `window.google` as always present, but it only
    // exists once the script has loaded — the runtime guard is real.

    if (window.google?.maps?.places) {
      resolve()
      return
    }

    window.__caiGoogleMapsLoaded = () => resolve()

    const params = new URLSearchParams({
      key: GOOGLE_MAPS_KEY,
      libraries: 'places',
      loading: 'async',
      callback: '__caiGoogleMapsLoaded',
    })

    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?${params}`
    script.async = true
    script.onerror = () => {
      loadPromise = null
      reject(new Error('Failed to load Google Maps JS API'))
    }
    document.head.appendChild(script)
  })

  return loadPromise
}
